// App chrome: header (title or back button) + scrollable screen body + bottom tab bar.
// The router calls renderChrome() then hands the returned body element to the screen.

import $ from 'jquery';
import type { RouteDef, TabKey } from '../screens/types';
import { getUnreadCount } from '../session';
import { esc } from './dom';

interface Tab {
  key: TabKey;
  icon: string;
  label: string;
  href: string;
}

const TABS: Tab[] = [
  { key: 'home', icon: '🏀', label: 'Oyunlar', href: '#/home' },
  { key: 'create', icon: '➕', label: 'Oluştur', href: '#/create' },
  { key: 'friends', icon: '👥', label: 'Çevrem', href: '#/friends' },
  { key: 'profile', icon: '👤', label: 'Profil', href: '#/profile' },
];

/** The notifications bell lives in the header's top-right, with a live unread badge. */
function bellHtml(): string {
  const unread = getUnreadCount();
  const badge = unread > 0 ? `<span class="tabbar__badge">${unread > 9 ? '9+' : unread}</span>` : '';
  return `<a class="app-header__bell" href="#/notifications" aria-label="Bildirimler">
      <span class="tabbar__icon">🔔${badge}</span>
    </a>`;
}

function headerHtml(route: RouteDef): string {
  // Show the bell everywhere except on the notifications screen itself.
  const right = route.pattern === '/notifications' ? '' : bellHtml();
  const left = route.back
    ? `<button class="app-header__back" id="nav-back" aria-label="Geri">‹</button>`
    : '';
  return `
    <div class="app-header">
      ${left}
      <h1 class="app-header__title">${esc(route.title)}</h1>
      <div class="app-header__spacer"></div>
      ${right}
    </div>`;
}

function tabbarHtml(active?: TabKey): string {
  const items = TABS.map((t) => {
    const cls = t.key === active ? 'tabbar__item is-active' : 'tabbar__item';
    return `<a class="${cls}" href="${t.href}">
      <span class="tabbar__icon">${t.icon}</span>
      <span>${esc(t.label)}</span>
    </a>`;
  }).join('');
  return `<nav class="tabbar">${items}</nav>`;
}

/** Render the chrome for a route and return the body container for the screen. */
export function renderChrome(route: RouteDef): JQuery {
  const showTabs = Boolean(route.tab);
  $('#app').html(`
    ${headerHtml(route)}
    <div class="screen" id="screen-body"></div>
    ${showTabs ? tabbarHtml(route.tab) : ''}
  `);

  if (route.back) {
    $('#nav-back').on('click', () => {
      if (history.length > 1) history.back();
      else location.hash = '#/home';
    });
  }

  return $('#screen-body');
}

/** Render just the chrome for a full-bleed screen (e.g. sign-in) with no header/tabs. */
export function renderBare(): JQuery {
  $('#app').html('<div class="screen screen--bare" id="screen-body"></div>');
  return $('#screen-body');
}
